<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="mySocketTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
            <template slot="operation" slot-scope="text, record">
                <!-- <router-link class="tableLink" :to="{path:'detail_templete',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_templete',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm> -->
                <a-popconfirm title="确认重新推送?" @confirm="() => handleRepush(record)">
                    <a class="tableLink"  href="javascript:;">重新推送</a>
                </a-popconfirm>
            </template>

            <template slot="status_name" slot-scope="text">
                <span :style="{color:text == '01' ? 'red' : 'green'}">{{ text == '01' ? '未回执' : '已发送' }}</span>
            </template>

            <!-- 业务埋点Attrabutes -->
            <template slot="jsonParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJson(record)" />
            </template>

            <!-- 业务埋点Attrabutes -->
            <template slot="jsonParamsData" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJsonData(record)" />
            </template>
 <!-- 设备号 -->
            <template slot="devicenoBtn" slot-scope="text,record">
                <a-button type="link" @click="handleDeviceNo(record)">{{ text }}</a-button>
            </template>
            
        </a-table>
        <a-modal v-model="jsonModalVisable" width="600px" title="attributes">
                <json-viewer
                :value="jsonVData"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-modal>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
import JsonViewer from "vue-json-viewer"
// content  createtime  devicelist  id  isplateform  msgtype  sendtype
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed:'left'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
        fixed:'left'
    },
    {
        title: "推送设备",
        dataIndex: "devicelist",
        scopedSlots : { customRender: 'devicenoBtn' },
        width:400,
        ellipsis: true
    },
    {
        title: "",
        width:50,
        scopedSlots: { customRender: 'jsonParams' },
        align: "center",
    },
    {
        title: "消息类型",
        dataIndex: "msgtype",
        width:100,
        ellipsis: true
    },
    
    {
        title: "发送方式",
        dataIndex: "sendtype",
        width:100,
        align:'center'
    },
    {
        title: "推送内容",
        dataIndex: "content",
        width:400,
        ellipsis: true,
        align:'center'
    },
    {
        title: "",
        width:50,
        scopedSlots: { customRender: 'jsonParamsData' },
        align: "center",
    },
    {
        title: "附加字段",
        dataIndex: "messageextras",
        width:100,
        ellipsis: true,
        align:'center'
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:160,
        align:'center'
    },

];
export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            orderstr:'desc',
            jsonModalVisable:false,
            searchP:{},
            jsonVData:[]
        };
    },
    methods: {
        handleDeviceNo(item){
            
            let routeResolve = this.$router.resolve({
                path:"/mcmsmanager/target/wsdeviceV3",
                query:{
                    deviceno:item.devicelist,
                }
            })
            window.open(routeResolve.href, '_blank');
        },
        handleParamsJson(item){
            this.jsonVData = item.devicelist.split(',')
            this.jsonModalVisable = true;
        },
        handleParamsJsonData(item){
            this.jsonVData = JSON.parse(item.content)
            this.jsonModalVisable = true;
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(){

        },
        handleRepush(record){
            let that = this
            that.tloading = true;
            let params = {
                id:record.id,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/sendmsgv3thistory",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.message.success('发送成功')
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        getAppSumData(){
            let that = this
            that.tloading = true;
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/querymsghistoryv3page",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },

    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

